export default class NewarcUser {
  constructor(firebaseId, data = {}) {
    this.firebaseId = firebaseId || '';
    this.id = data.id || '';
    this.name = data.name ?? '';
    this.surname = data.surname ?? '';
    this.email = data.email ?? '';
    this.type = data.type || 'web-client';
    this.role = data.role || 'web-client';
    this.isActive = data.isActive || true;
    this.isArchived = data.isArchived || false;
    this.isHiredInternally = false;
    this.menuAccess = {};
    this.projectTabAccess = {};
    this.isFilterPerAccountEnabled = false;
    this.phoneCode = data.phoneCode || '';
    this.phone = data.phone || '';
    this.source = data.source || 'web';
    this.brand = data.brand || 'newarc';
    this.insertTimestamp = data.insertTimestamp || Date.now();
    this.profilePicture = data.profilePicture;
  }

  toMap() {
    return {
      id: this.id,
      name: this.name,
      surname: this.surname,
      email: this.email,
      type: this.type,
      role: this.role,
      isActive: this.isActive,
      isArchived: this.isArchived,
      isHiredInternally: this.isHiredInternally,
      menuAccess: this.menuAccess,
      projectTabAccess: this.projectTabAccess,
      isFilterPerAccountEnabled: this.isFilterPerAccountEnabled,
      phoneCode: this.phoneCode,
      phone: this.phone,
      source: this.source,
      brand: this.brand,
      insertTimestamp: this.insertTimestamp,
      profilePicture: this.profilePicture
    };
  }

  getFullName() {
    return `${this.name} ${this.surname}`;
  }

  

  
}
